var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3335 49.3333H22.6668M22.6668 49.3333H39.3335M22.6668 49.3333V26.3337C22.6668 24.4668 22.6668 23.5327 23.0301 22.8197C23.3497 22.1925 23.8593 21.6829 24.4865 21.3633C25.1995 21 26.1336 21 28.0005 21H34.0005C35.8673 21 36.7994 21 37.5125 21.3633C38.1397 21.6829 38.651 22.1925 38.9705 22.8197C39.3335 23.532 39.3335 24.465 39.3335 26.3282V36M39.3335 49.3333H49.3335M39.3335 49.3333V36M49.3335 49.3333H52.6668M49.3335 49.3333V36C49.3335 34.4469 49.3333 33.6707 49.0796 33.0581C48.7413 32.2413 48.093 31.592 47.2762 31.2537C46.6636 31 45.8862 31 44.3331 31C42.7799 31 42.0034 31 41.3908 31.2537C40.574 31.592 39.9255 32.2413 39.5872 33.0581C39.3335 33.6707 39.3335 34.4469 39.3335 36M27.6668 32.6667H34.3335M27.6668 27.6667H34.3335",
    stroke: "#191919",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableIcon);
export default __webpack_public_path__ + "static/media/tableIcon.0625a92ccf0e6a1eea04bc268fd9d211.svg";
export { ForwardRef as ReactComponent };